import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from '../environments/environment';
import { CmsCampaignComponent } from './cms-campaign/cms-campaign.component';
import { CmsLoginComponent } from './cms-login/cms-login.component';
import { CmsGuardGuard } from './cms-guard.guard';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { PeopleComponent } from './people/people.component';
import { ProjectsComponent } from './projects/projects.component';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent
  }, {
    path: 'cms-campaign',
    component: CmsCampaignComponent
    // canActivate: [CmsGuardGuard]
  }, {
    path: 'about',
    component: AboutComponent
  }, {
    path: 'contact',
    component: ContactComponent
  }, {
    path: 'people',
    component: PeopleComponent
  }, {
    path: 'projects',
    component: ProjectsComponent
  }, {
    path: 'cms-login',
    component: CmsLoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes),
  AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
